"use strict";

require("core-js/modules/es6.string.trim");

var _slicedToArray = require("/Users/karson.tan/Projects/1to30/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

var _classCallCheck = require("/Users/karson.tan/Projects/1to30/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var cars = require("../../../fixtures/regexes/device/car_browsers.json");

var CarParser = function CarParser() {
  _classCallCheck(this, CarParser);

  this.parse = function (userAgent) {
    var result = {
      type: "",
      brand: "",
      model: ""
    };

    for (var _i = 0, _Object$entries = Object.entries(cars); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          brand = _Object$entries$_i[0],
          car = _Object$entries$_i[1];

      var match = user_agent_1.userAgentParser(car.regex, userAgent);
      if (!match) continue;
      result.type = "car";
      result.brand = brand;

      if (car.model) {
        result.model = variable_replacement_1.variableReplacement(car.model, match).trim();
      }

      break;
    }

    return result;
  };
};

exports["default"] = CarParser;